import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ bills }) => {
    const rows = bills.map(bill => <TableRow key={bill.id} {...bill} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Bills/TableBody.js